import React from "react";
import { FormSectionProps } from "../../../models/form-types";
import { CollapsibleFormSection } from "./CollapsibleFormSection";

export const FormSection: React.FC<FormSectionProps> = ({
  title,
  children,
  className,
  id,
}) => {
  return (
    <CollapsibleFormSection id={id} title={title} className={className}>
      {children}
    </CollapsibleFormSection>
  );
};
